import http from 'axios'

export default {
  incrementerAccesSouscriptionAbonnement: (numtiers, fonctionnalite) => {
    return http.put(`/web/v1/${numtiers}/abonnement/acces-souscription?fonctionnalite=${fonctionnalite}`)
  },
}
